import React, { useEffect, useState } from 'react';

// Reassuring rotating messages so a longer wait never feels "frozen"
const REASSURING_MESSAGES = [
  'Loading your data…',
  'Almost there…',
  'Getting things ready…',
  'Fetching the latest…',
];

// Branded dual-ring spinner
export const Spinner = ({ size = 24, className = '' }) => (
  <span
    className={`inline-block rounded-full border-[3px] border-orange-500/25 border-t-orange-500 animate-spin ${className}`}
    style={{ width: size, height: size }}
    data-testid="spinner"
    aria-label="loading"
    role="status"
  />
);

// Full-page loader used for app boot & route transitions
export const PageLoader = ({ label, subtle = false }) => {
  const [idx, setIdx] = useState(0);
  useEffect(() => {
    if (label) return; // static label -> no rotation
    const t = setInterval(() => setIdx((i) => (i + 1) % REASSURING_MESSAGES.length), 1800);
    return () => clearInterval(t);
  }, [label]);

  const message = label || REASSURING_MESSAGES[idx];

  return (
    <div
      className={`min-h-screen w-full flex items-center justify-center ${subtle ? 'bg-transparent' : 'bg-gray-50'}`}
      data-testid="page-loader"
    >
      <div className="flex flex-col items-center gap-4">
        <div className="relative h-14 w-14">
          <span className="absolute inset-0 rounded-full border-[3px] border-orange-500/20" />
          <span className="absolute inset-0 rounded-full border-[3px] border-transparent border-t-orange-500 animate-spin" />
          <span className="absolute inset-2 rounded-full border-[3px] border-transparent border-b-red-400 animate-spin [animation-duration:1.4s]" />
        </div>
        <p className="text-sm font-medium text-gray-500 animate-pulse" data-testid="page-loader-message">
          {message}
        </p>
      </div>
    </div>
  );
};

// In-flow loader for a section/panel/tab (keeps surrounding chrome visible)
export const SectionLoader = ({ label = 'Loading…', className = '' }) => (
  <div
    className={`w-full flex flex-col items-center justify-center py-16 gap-3 ${className}`}
    data-testid="section-loader"
  >
    <Spinner size={34} />
    <p className="text-sm text-gray-500">{label}</p>
  </div>
);

export default PageLoader;
